export enum FieldDataType {
    None = 0,
    Boolean = 12,
    Currency = 11,
    Date = 9,
    DateTime = 8,
    Double = 5,
    Float = 4,
    LongInteger = 3,
    String = 6,
    Time = 10
}

export enum FieldDisplayType {
    Edit = 0,
    MaskEdit = 1,
    Lookup = 2
}

export enum FieldStates {
    None = 1,
    Focus = 2,
    Duplicate = 4
}

export enum FieldMaskStorage {
    UserData,
    /**
     * @deprecated
     */
    Literals,
    /**
     * @deprecated
     */
    Spaces,
    IncludePlaceholders,
    IncludeLiteralsAndPlaceholders,
    IncludeLiterals
}

export enum SystemFields {
    AsciiLength = 10,
    BatchName = 16,
    CreatedTime = 500,
    Creator = 501,
    Deleted = 12,
    Description = 13,
    DocumentId = 2,
    ExpirationDate = 15,
    FileFormat = 505,
    FirstPageThumbnail = 601,
    Keywords = 600,
    LargeBlip = 4,
    MasterId = 14,
    MediumBlip = 5,
    MediumType = 9,
    ModifiedTime = 502,
    Modifier = 503,
    None = 0,
    Pages = 504,
    RemarksId = 507,
    RollId = 3,
    SmallBlip = 6,
    SoftformId = 506,
    StartAddress = 7,
    Suffix = 8,
    Version = 11,
    VersionLabel = 602,
    VersionTimestamp = 603,
    CreatorName = 604,
    ModifierName = 605,
    RollFilmName = 606,
    Device = 607,
    Application = 608,
    Archive = 609,
    HasRemarks = 610,
    HasVersions = 611,
    HasKeywords = 612,
    IsLocked = 613,
    HasAnnotations = 614,
    IsExpired = 615,
    VolumeId = 1
}